<template>
  <div class="g-container-p">
    <div class="m-container-p">
      <!-- 面包屑 -->
      <div>
        <h3 style="margin-bottom: 0.6%;">
          <slot name="title"></slot>
        </h3>
        <h4>1.原材料储存:</h4>
        <span>要求：应储存在通风、干燥且阴凉的环境，避免阳光直射和高温；冬天时应注意材料保暖，不得露天霜冻。（上传原材料储存现场照片）。</span>
        <image-upload :src="src"
                      :isPic="true"
                      :picImgs="rowPicDataArr"
                      @getDataArrPic="getDataArrPic"
                      style="width: 80%; padding: 20px 0px 0px 0px;">
          <i slot="del"
             class="del-p"></i>
        </image-upload>
        <slot name="radioInfo"></slot>
        <template>
          <div v-show="rawMaterialCheckFlag">
            <h4 style="margin-top: 20px;">2.原材料抽检：</h4>
            <span>上传抽检过程照片、填写送检检测机构名称、检测结果描述（必要时上传检测报告扫描件）。</span>
            <image-upload :src="src"
                          :isPic="true"
                          :picImgs="rowCheckPicDataArr"
                          @getDataArrPic="getRowCheckDataArrPic"
                          style="width: 80%;padding: 20px 0;">
              <i slot="del"
                 class="del-p"></i>
            </image-upload>
            <slot name="checkInfo"></slot>
            <el-upload class="upload-demo"
                       drag
                       action="https://www.iduilv.com/Api/Common/UploadFile"
                       :data="extraData"
                       :before-upload="beforeUpload"
                       :file-list="oldRowCheckFileList"
                       :limit="1"
                       accept=".pdf"
                       multiple
                       :on-success="handleSuccess"
                       :on-error="handleError"
                       :on-remove="handleRemove"
                       style="width: 80%;">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import "../../../../../html/pages/originality/createTestReport/createTestReport.scss"

import imageUpload from "../../../../../components/imageUpload/qeImageUpload"

export default {
  name: 'rawMaterialEnter',
  props: ['oldRowPicDataArr', 'oldRowCheckPicDataArr', 'oldRowCheckFileList', 'rawCheckFlag'],
  watch: {
    oldRowPicDataArr (newValue) {
      this.rowPicDataArr = newValue;
      //console.log("oldRowPicDataArr", this.rowPicDataArr)
    },
    oldRowCheckPicDataArr (newValue) {
      this.rowCheckPicDataArr = newValue;
      //console.log("oldRowCheckPicDataArr", this.rowCheckPicDataArr)
    },
    rawCheckFlag (newValue) {
      this.rawMaterialCheckFlag = newValue;
      //console.log("rawCheckFlag", newValue)
    },
  },
  data () {
    return {
      src1: require("../../../../../html/pages/originality/createQe/images/upload.jpg"),
      rowPicDataArr: this.oldRowPicDataArr,//原材料存储原图
      rowCheckPicDataArr: this.oldRowCheckPicDataArr,//原材料抽检原图
      titleText: "",
      type: "",
      rawMaterialCheckFlag: this.rawCheckFlag,
      extraData: {//原材料抽检文件
        type: 'file',
        file: ''
      },
    }
  },
  components: {
    imageUpload
  },
  computed: {
    src () {
      return this.src1
    }
  },
  methods: {
    getDataArrPic (data) {
      this.rowPicDataArr = data
      this.$emit('getRowEnterDataArr', this.rowPicDataArr, this.rowCheckPicDataArr, this.extraData);
    },
    getRowCheckDataArrPic (data) {
      this.rowCheckPicDataArr = data
      this.$emit('getRowEnterDataArr', this.rowPicDataArr, this.rowCheckPicDataArr, this.extraData);
    },
    beforeUpload (file) {
      const isPDF = file.type === 'application/pdf';
      const isLt20M = file.size / 1024 / 1024 < 20;

      if (!isPDF) {
        this.$message.error('上传文件只能是PDF格式!');
      }
      if (!isLt20M) {
        this.$message.error('上传文件大小不能超过 20MB!');
      }

      return isPDF && isLt20M;
    },
    handleSuccess (response, file, fileList) {
      // 成功回调
      console.log(response)
      if (response.Type == 'Success') {
        this.$message.success(response.Content)
        this.extraData.file = response.Data
      }
      this.$emit('getRowEnterDataArr', this.rowPicDataArr, this.rowCheckPicDataArr, this.extraData);
      console.log(response.response.Data, file, fileList)
    },
    // 删除文件
    handleRemove (file, fileList) {
      this.extraData.file = '';
      this.$emit('getRowEnterDataArr', this.rowPicDataArr, this.rowCheckPicDataArr, this.extraData);
    },
    handleError (err, file, fileList) {
      // 错误回调
      console.log(err, file, fileList)
    },
    // 上传报告
    async uploadReprot (fn) {

    },
    init () {
      this.type = this.$route.query.type
    },
    created () {
      this.init()
    },
    beforeRouteUpdate (to, from, next) {
      next();
      this.init();
      this.picDataArr = []
    },
    reload () {
      this.uploadReprot(item => {
        window.location.reload()
      })
    },
  },
}
</script>

<style scoped>
</style>
